
import { useParams } from 'react-router-dom';
import LogoRef from '../../assets/img/logoRef.png';
import AmountFormatter from '../../utils/AmountFormatter';
import { ServerRequestProtectedOCR } from '../../utils/ServerDataRequest';
import NotificationHandler from '../../utils/NotificationHandler';
import isNull from '../../utils/NullChecking';
import { useEffect, useRef } from 'react';
import { enumUtil } from '../../utils/Enum';
import { useState } from 'react';
import Loader from '../shared/Loader/Loader';
import useCaptureDataAndGeneratePDFBrowserAPI from '../shared/CaptureDataAndGeneratePDF/useCaptureDataAndGeneratePDFBrowserAPI';
import isAmountNull from '../../utils/AmountNullChecker';
import { useSelector } from 'react-redux';
const ViewPaidReceipt = () => {
    //{ paymentDetails, procedureCodeData } props
    const { paymentId } = useParams();
    const componentRef = useRef(null);
    const API_URL_Payment = enumUtil.controller.PatientPay
    const [isLoading, setIsLoading] = useState(false)
    const [paymentDetails, setpaymentDetails] = useState({})
    const [procedureCodeData, setprocedureCodeData] = useState([])
    const { isLoading: isLoadingPdf, captureDataAndGeneratePDF } = useCaptureDataAndGeneratePDFBrowserAPI();
    // const paymentId = hash.replace("#/ViewPaidReceipt", "");
    const getReceiptData = () => {
        if (!isNull(paymentId)) {
            setIsLoading(true)
            ServerRequestProtectedOCR(API_URL_Payment + "/GetPaymentReceipt", 'post', {
                "TableName": "COLLECTPATIENTPAYMENTS",
                "ID": paymentId + ""
            }).then((response) => {
                setIsLoading(false)
                setpaymentDetails(response)
                setprocedureCodeData(response.servicelineData)
            }).catch((error) => {
                setIsLoading(false)
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
            })
        }
    }
    useEffect(() => {
        if (isNull(paymentId)) return;
        getReceiptData()
    }, [paymentId])
        const ThemeConfiguration = useSelector((state) => state.Theme?.theme) || JSON.parse(localStorage.getItem("themeConfig") || "null");
    return (
        <div className="ar_payment_receipt_print d-flex flex-column gap-50">
            {isLoading ? <Loader /> : null}
            <div className="ar_orange-header d-flex align-items-center justify-content-center" >
                <p className="text text-decoration-underline fs-13 font-m text-white user-select-none cursor-pointer"
                    onClick={() => captureDataAndGeneratePDF(componentRef, 'Patient Payment', '')}>Print Receipt</p>
            </div>

            <div className="d-flex justify-content-center pb-3" ref={componentRef}>
                <div className="ar_native_pdf_design ar_print-Payment_Receipt p-40 d-flex flex-column row-gap-30">
                    <div className="practice_header d-flex flex-column gap-16">
                        {(!isNull(paymentDetails?.practiceData?.practiceLogo)) ?
                            <img src={paymentDetails?.practiceData?.practiceLogo} alt="" style={{ maxHeight: '55px' }} className="w-max-content" crossOrigin="anonymous" />
                            :
                            <div className="d-flex align-items-center gap-1">
                                <i className="icon-no-image"></i>
                                <p className="text fs-10 ar-light-color">Practice Logo</p>
                            </div>
                        }

                        <div className="d-flex justify-content-between align-items-end">
                            <div className="d-flex flex-column gap-6">
                                <p className="heading fs-16 text-black">{paymentDetails?.practiceData?.practiceName}</p>
                                <p className="text fs-13 clr-363C45">{paymentDetails?.practiceData?.practiceAddress}</p>
                                <p className="text fs-13 clr-363C45">
                                    {paymentDetails?.practiceData?.practicePaymentEmail ?
                                        paymentDetails?.practiceData?.practicePaymentEmail + " | " : paymentDetails?.practiceData?.email ?
                                            paymentDetails?.practiceData?.email + " | " : ''}
                                    {paymentDetails?.practiceData?.statementPhoneNo ?
                                        paymentDetails?.practiceData?.statementPhoneNo : paymentDetails?.practiceData?.practiceNo ?
                                            paymentDetails?.practiceData?.practiceNo : ''}</p>
                            </div>

                            <div className="d-flex flex-column gap-6">
                                <div className="d-flex align-items-center gap-16">
                                    <p className="text clr-363C45">Receipt #</p>
                                    <p className="text fs-13 text-black">{paymentDetails?.practiceData?.receiptNo}</p>
                                </div>
                                <div className="d-flex align-items-center gap-16">
                                    <p className="text clr-363C45">Date Paid</p>
                                    <p className="text fs-13 text-black">{paymentDetails?.practiceData?.datePaid}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="billed-box-content d-flex flex-column gap-5">
                        <p className="text font-m fs-16 orange-drk">Billed To:</p>
                        <div className="d-flex flex-column gap-6">
                            <p className="heading text-black fs-16">{paymentDetails?.patientData?.patient}</p>
                            <p className="text fs-13 text-black">Address: {paymentDetails?.patientData?.patientAddress ? paymentDetails?.patientData?.patientAddress : 'N/A'}</p>
                            <div className="d-flex align-items-center gap-1">
                                <p className="text fs-13 text-black">Amount Paid:</p>
                                <p className="heading fs-13 text-black"><AmountFormatter amount={paymentDetails?.patientData?.amountPaid} /></p>
                            </div>
                            <p className="text fs-13 text-black">Payment Method: {paymentDetails?.patientData?.paymentMethd}</p>
                        </div>
                    </div>

                    <div className="">
                        <div className="ar_table">
                            <table className="w-100">
                                <thead>
                                    <tr>
                                        <th className="heading text-white text-nowrap fs-13">Date of Service</th>
                                        <th className="heading text-white text-nowrap fs-13">CPT</th>
                                        <th className="heading text-white fs-13">Description</th>
                                        {/* <th className="heading text-white fs-13">Amount Due</th> */}
                                        <th className="heading text-white text-nowrap fs-13 w-107px">Paid</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {procedureCodeData?.length > 0 && procedureCodeData.map((item, index) => (
                                        <tr>
                                            <td className="text text-black fs-13">{item?.Dos}</td>
                                            <td className="text text-black fs-13">{item?.CPT}</td>
                                            <td className="text text-black fs-13">{item?.Description}</td>
                                            {/* <td className="text text-black fs-13"><AmountFormatter amount={item?.TotalBalance} /></td> */}
                                            <td className="text text-black fs-13"><AmountFormatter amount={item?.unitAmount} /></td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <div className="d-flex flex-column align-items-end">
                            <div className="">
                                <div className="total-amount-detail pe-0">
                                    <div className="">
                                        <div className="d-flex flex-column gap-4">
                                            {/* <div className="d-flex align-items-center gap-2">
                                                <p className="text fs-13 clr-363C45 w-125px">Sub Total</p>
                                                <p className="text fs-13 text-black min-w-107px ps-2"><AmountFormatter amount={paymentDetails?.patientData?.subTotal} /></p>
                                            </div> */}
                                            <div className="d-flex align-items-center gap-2">
                                                <p className="text fs-13 clr-363C45 w-100">Amount Paid</p>
                                                <p className="heading fs-13 orange-drk min-w-107px ps-2"><AmountFormatter amount={paymentDetails?.patientData?.amountPaid} /></p>
                                            </div>
                                        </div>
                                        {/* <div className="d-flex align-items-center gap-2 balance-content">
                                            <p className="text fs-13 clr-363C45 w-125px">Remaining Due</p>
                                            <p className="heading fs-16 text-black min-w-107px ps-2"><AmountFormatter amount={paymentDetails?.patientData?.balance} /></p>
                                        </div> */}
                                    </div>

                                </div>
                                <div className="py-2 px-12 ps-4">
                                    <p className="text clr-363C45">If you have any question contact us at </p>
                                    <p className="text font-m orange-clr">{paymentDetails?.practiceData?.practicePaymentEmail}</p>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div className='text-center pt-1-5 br-top-1 za_br_light mt-5'>
                        <p className="text ar-light-color">Receipt Generated by {ThemeConfiguration?.configuration?.company?.name} (<a href="https://starhealthcare.co" className="ar-hover-text ar-light-color text" target="_blank" rel="noopener noreferrer" >https://starhealthcare.co</a>)</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ViewPaidReceipt